import { render, staticRenderFns } from "./User.vue?vue&type=template&id=ebcb51fe&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb51fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebcb51fe')) {
      api.createRecord('ebcb51fe', component.options)
    } else {
      api.reload('ebcb51fe', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=ebcb51fe&scoped=true&", function () {
      api.rerender('ebcb51fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/propertySetting/User.vue"
export default component.exports